import { Controller } from "@hotwired/stimulus"

// Wraps the global Inputmask library — applies the mask from the
// `data-inputmask-mask-value` attribute to the controller's element on
// connect.
//
// Usage:
//   <input data-controller="inputmask" data-inputmask-mask-value="+7 999 999-99-99" />
export default class extends Controller {
  static values = { mask: String }

  connect() {
    if (window.Inputmask && this.maskValue) {
      window.Inputmask(this.maskValue).mask(this.element)
    }
  }
}
